import * as Yup from 'yup';

import { translate } from '@utils';

import { PaymentStatusTypes } from './propertyType.types';

export const getValidationSchema = () => {
  return Yup.string<PaymentStatusTypes>().required(
    translate('subModules/paymentType:validation.required')
  );
};
